import React from 'react';

const AlertBar = ({ text, enabled }) => {
  if (!enabled || !text) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-amber-500 text-black overflow-hidden"
      data-testid="alert-bar"
      style={{ height: '48px' }}
    >
      <div className="h-full flex items-center animate-marquee whitespace-nowrap">
        <span className="text-lg font-bold mx-8">
          {text}
        </span>
        <span className="text-lg font-bold mx-8">
          {text}
        </span>
        <span className="text-lg font-bold mx-8">
          {text}
        </span>
        <span className="text-lg font-bold mx-8">
          {text}
        </span>
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default AlertBar;
